import spiderman from '@/spiderman';

import auth from './auth';
import membership from './membership';
import appointments from './appointments';
import feedbacks from './feedbacks';
import visitorRegistrations from './visitor-registrations';
import chatPictures from './chat-pictures';

const { chatSocket } = spiderman.api;

export default {
  auth,
  membership,
  appointments,
  feedbacks,
  visitorRegistrations,
  chatPictures,
  chatSocket,
};
